module.exports = __webpack_public_path__ + "img/header-contact..f781ab54.png";